module.exports = __webpack_public_path__ + "media/images/extension-onboarding/extension-e9488ecff3566aefc5d979442735f839.svg";